import type { AssignmentNotificationContext } from 'src/apis/notification-service/types';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const notificationsContextLabels: Record<
  AssignmentNotificationContext,
  string
> = {
  ASSIGNMENTS: 'Assignments',
};

export const notificationsContextValues = labelsToValues(
  notificationsContextLabels
);
export const notificationsContextOptions = labelsToOptions(
  notificationsContextLabels
);
